import { $api } from "../AxiosInstance";

export class BrowserAddonService {
  // User Agents
  static async getUserAgents() {
    return await $api.get("/api/admin/userAgent/all");
  }

  static async getUserAgentById(id) {
    return await $api.get("/api/admin/userAgent", { params: { id } });
  }

  static async createUserAgent(params) {
    return await $api.put("/api/admin/userAgent", params);
  }

  static async updateUserAgent(params) {
    return await $api.post("/api/admin/userAgent", params);
  }

  static async deleteUserAgent(id) {
    return await $api.delete("/api/admin/userAgent", { params: { id } });
  }

  static async changeUserAgentsIndices(userAgentSortedIds) {
    return await $api.post("/api/admin/userAgent/changeIndices", {
      userAgentSortedIds,
    });
  }

  // User Devices
  static async getUserDevicesByEmail(email) {
    return await $api.get("/api/admin/browserUserToken/email", { params: { email } });
  }

  static async getUserDeviceByID(token) {
    return await $api.get("/api/admin/browserUserToken/token", { params: { token } });
  }
}
